import { render, staticRenderFns } from "./TeamIJoined.vue?vue&type=template&id=4bdbe1bd&scoped=true"
import script from "./TeamIJoined.vue?vue&type=script&lang=ts"
export * from "./TeamIJoined.vue?vue&type=script&lang=ts"
import style0 from "./TeamIJoined.vue?vue&type=style&index=0&id=4bdbe1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbe1bd",
  null
  
)

export default component.exports